

    document.addEventListener('alpine:init', () => {

        Alpine.data('app_portefeuille_edit', (routeupdate, stripe_key ) => ({

            init() {
                this.loadportefeuille();
            },
            loadportefeuille() {
                // Configuration de Stripe.js avec votre clé publique
                var stripe = Stripe(stripe_key);

                // Création de l'élément de carte de crédit
                var elements = stripe.elements();
                var cardElement = elements.create('card');

                // Montrez l'élément de carte de crédit dans le formulaire
                cardElement.mount('#card-element');

                // Gestionnaire d'événements pour la soumission du formulaire
                var form = document.getElementById('payment-form');
                var fdlt_self = this;
                form.addEventListener('submit', function (event) {
                    event.preventDefault();
                    var _fdlt_self = fdlt_self;
                    // Génération du token Stripe et envoi du formulaire
                    stripe.createToken(cardElement).then(function (result) {

                        var __fdlt_self = _fdlt_self;
                        if (result.error) {
                            // Gestion des erreurs de validation
                            console.error(result.error.message);
                        } else {
                            // Envoi du token Stripe au serveur
                            var token = result.token.id;
                            var hiddenInput = document.createElement('input');
                            hiddenInput.setAttribute('type', 'hidden');
                            hiddenInput.setAttribute('name', 'stripeToken');
                            hiddenInput.setAttribute('value', token);
                            form.appendChild(hiddenInput);

                            // Soumettre le formulaire
                            //form.submit();

                            // Préparez les données à envoyer avec Axios
                            const formData = new FormData(form);

                            // Obtenez l'URL du formulaire
                            const formAction = form.getAttribute('action');

                            // Utilisez Axios pour envoyer la requête POST
                            axios.post(formAction, formData)
                                .then(response => {
                                    if (response.data.success) {
                                        // Le serveur a bien reçu et traité la transaction
                                        // Affichez un message de succès ou effectuez d'autres actions nécessaires
                                        __fdlt_self.$dispatch('notifypmsuccess', {})
                                    } else {
                                        // La transaction a échoué sur le serveur
                                    }
                                })
                                .catch(error => {
                                    console.error(error);
                                    // Gérer les erreurs d'Axios
                                });
                        }
                    });
                });
            },
        }))
    })





